"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILSubtitle1Args = exports.ILSubtitle1 = exports.ILH6Args = exports.ILH6 = exports.ILH5Args = exports.ILH5 = exports.ILH4Args = exports.ILH4 = exports.ILH3Args = exports.ILH3 = exports.ILH2Args = exports.ILH2 = exports.ILH1Args = exports.ILH1 = exports.ILCaptionArgs = exports.ILCaption = exports.ILButtonTextArgs = exports.ILButtonText = exports.ILBody2Args = exports.ILBody2 = exports.ILBody1Args = exports.ILBody1 = void 0;
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
/**
 * Default Args
 * the default component properties
 */
var defaultArgs = {
    sx: {
        color: 'text.primary',
    },
};
var ILH1Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H1 });
exports.ILH1Args = ILH1Args;
var ILH1 = (0, get_component_1.getComponent)(Typography_1.default, ILH1Args);
exports.ILH1 = ILH1;
var ILH2Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H2 });
exports.ILH2Args = ILH2Args;
var ILH2 = (0, get_component_1.getComponent)(Typography_1.default, ILH2Args);
exports.ILH2 = ILH2;
var ILH3Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H3 });
exports.ILH3Args = ILH3Args;
var ILH3 = (0, get_component_1.getComponent)(Typography_1.default, ILH3Args);
exports.ILH3 = ILH3;
var ILH4Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H4 });
exports.ILH4Args = ILH4Args;
var ILH4 = (0, get_component_1.getComponent)(Typography_1.default, ILH4Args);
exports.ILH4 = ILH4;
var ILH5Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H5 });
exports.ILH5Args = ILH5Args;
var ILH5 = (0, get_component_1.getComponent)(Typography_1.default, ILH5Args);
exports.ILH5 = ILH5;
var ILH6Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.H6 });
exports.ILH6Args = ILH6Args;
var ILH6 = (0, get_component_1.getComponent)(Typography_1.default, ILH6Args);
exports.ILH6 = ILH6;
var ILSubtitle1Args = __assign(__assign({}, defaultArgs), { sx: {
        color: 'text.secondary',
    }, variant: enums_1.TypographyVariantEnum.SUBTITLE1 });
exports.ILSubtitle1Args = ILSubtitle1Args;
var ILSubtitle1 = (0, get_component_1.getComponent)(Typography_1.default, ILSubtitle1Args);
exports.ILSubtitle1 = ILSubtitle1;
var ILBody1Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.BODY1 });
exports.ILBody1Args = ILBody1Args;
var ILBody1 = (0, get_component_1.getComponent)(Typography_1.default, ILBody1Args);
exports.ILBody1 = ILBody1;
var ILBody2Args = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.BODY2 });
exports.ILBody2Args = ILBody2Args;
var ILBody2 = (0, get_component_1.getComponent)(Typography_1.default, ILBody2Args);
exports.ILBody2 = ILBody2;
var ILCaptionArgs = __assign(__assign({}, defaultArgs), { sx: {
        color: 'text.secondary',
    }, variant: enums_1.TypographyVariantEnum.CAPTION });
exports.ILCaptionArgs = ILCaptionArgs;
var ILCaption = (0, get_component_1.getComponent)(Typography_1.default, ILCaptionArgs);
exports.ILCaption = ILCaption;
var ILButtonTextArgs = __assign(__assign({}, defaultArgs), { variant: enums_1.TypographyVariantEnum.BUTTON });
exports.ILButtonTextArgs = ILButtonTextArgs;
var ILButtonText = (0, get_component_1.getComponent)(Typography_1.default, ILButtonTextArgs);
exports.ILButtonText = ILButtonText;
